module.exports = __webpack_public_path__ + "img/34.8c9d3c76.png";